import { RouteObject } from 'react-router';

import { DashboardPageLazy } from './page.tsx';

import { RoleProtectedRoute } from '@/services/roles';
import { EAdminRoutes } from '@/services/router/enums';

export const DASHBOARD_ROUTE: RouteObject = {
    path: EAdminRoutes.Dashboard,
    element: (
        <RoleProtectedRoute path={EAdminRoutes.Dashboard}>
            <DashboardPageLazy />
        </RoleProtectedRoute>
    ),
};
